import { z } from 'zod/v4';

export const assetDeleteResultSchema = z.object({
  ErrorCode: z.string().nullable(),
  TotalAssetsDeleted: z.number(),
});

// Can't z.infer because of name changes
export type AssetDeleteResult = {
  errorCode: null | string;
  totalAssetsDeleted: number;
};
